import { useEffect, useMemo, useState } from 'react'
import { Table, Space, Button, Form, Input, Modal, Select, Switch } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo, baseAxiosComplete } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout } from '../../js/globalParam'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

type pagination = {
    current: number,
    pageSize: number,
    total: number
}

type fetchParams = {
    store_id: string | undefined,
    material_type_id: string | undefined,
    material_name: string | undefined,
    material_code: string | undefined,
    is_use: number | undefined
}

const initForm = {
    store_id: undefined,
    material_type_id: undefined,
    material_name: undefined,
    material_code: undefined,
    material_unit: undefined,
    cost_price: undefined,
    is_use: undefined
}

export default function ConfigActivityList() {

    let paginatioTml = {
        current: 1,
        pageSize: 8,
        total: 0
    }

    let otherParamsTml = {
        store_id: undefined,
        material_type_id: undefined,
        material_name: undefined,
        material_code: undefined,
        is_use: undefined
    }

    const [pagination, setPagination] = useState<pagination>(paginatioTml)
    const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)

    const [tableList, setTableList] = useState<any[]>([])
    const [optionStoreData, setOptionStoreData] = useState<{}[]>([])
    const [optionTypeData, setOptionTypeData] = useState<{}[]>([])

    const [form] = Form.useForm()
    const [addVisible, setAddVisible] = useState<boolean>(false)
    const [recordID, setRecordID] = useState<string | undefined>(undefined)

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        // 查询门店列表
        baseAxiosNoInfo('/global/store_list').then((response: any) => {
            if (response) {
                setOptionStoreData(response)
            }
        })

        // 查询物料分类列表
        baseAxiosNoInfo('/global/material_type_list').then((response: any) => {
            if (response) {

                setOptionTypeData(response)
            }
        })

        fetch({ pagination, otherParams })
    }, [pagination.current])

    const handleQueryChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(otherParams)
        params[attr] = value

        setOtherParams(params)
    }

    const handleSearch = () => {
        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, otherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...otherParams }

        axiosTable.get('/yuezi_center/material/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setTableList(response.records)
            }
        })
    }

    const resetForm = () => {
        setOtherParams(otherParamsTml)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, otherParams: otherParamsTml })
    }

    const onFinish = (values: any) => {
        let url = recordID ? '/yuezi_center/material/update' : '/yuezi_center/material/add'

        if (recordID) {
            values.id = recordID
        }

        baseAxiosComplete.post(url, {
            ...values

        }).then(res => {
            if (res.status === 0) {
                setAddVisible(false)
                form.setFieldsValue(initForm)

                resetForm()
            }
        })
    }

    let optionStore = optionStoreData.map((el: any) => (<Option value={el.store_id} key={el.store_id}>{el.store_name}</Option>))
    let optionType = optionTypeData.map((el: any) => (<Option value={el.material_type_id} key={el.material_type_id}>{el.material_type_name}</Option>))

    return (<div className="common-page">
        {/* 月子中心 -> 月子配置管理 -> 物料管理 */}
        <BreadCrumb position={['月子中心', '物料管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores valueProp="id" value={otherParams.store_id} onChange={(value: string) => { handleQueryChange(value, 'store_id') }} />
                </div>
                <Select allowClear virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 150 }} placeholder="物料分类" value={otherParams.material_type_id} onChange={(e: string) => { handleQueryChange(e, 'material_type_id') }} >
                    {optionType}
                </Select>

                <Input style={{ width: '120px', marginRight: 8, marginBottom: 12 }} placeholder="物料名称" value={otherParams.material_name} onChange={(e: { target: { value: string } }) => { handleQueryChange(e.target.value, 'material_name') }} />
                <Input style={{ width: '120px', marginRight: 8, marginBottom: 12 }} placeholder="物料编号" value={otherParams.material_code} onChange={(e: { target: { value: string } }) => { handleQueryChange(e.target.value, 'material_code') }} />

                <Select allowClear virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="是否启用" value={otherParams.is_use} onChange={(v: number) => { handleQueryChange(v, 'is_use') }}>
                    <Option value={0} key={0}>未启用</Option>
                    <Option value={1} key={1}>启用</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
                {permission.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => {
                    form.setFieldsValue(initForm)

                    setRecordID(undefined)
                    setAddVisible(true)
                }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={tableList} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="门店名称" dataIndex="store_name" key="store_name" />
                <Column title="分类名称" dataIndex="material_type_name" key="material_type_name" />
                <Column title="物料名称" dataIndex="material_name" key="material_name" />
                <Column title="物料编号" dataIndex="material_code" key="material_code" />
                <Column title="物料单位" dataIndex="material_unit" key="material_unit" />
                <Column title="成本价格" dataIndex="cost_price" key="cost_price" />
                <Column title="是否启用" dataIndex="is_use" key="is_use" render={(text, record: any) => (
                    <Space size="middle">
                        <Switch checked={record.is_use == undefined || record.is_use == null || record.is_use == 0 ? false : true} onClick={() => {
                            baseAxiosComplete.post('/yuezi_center/material/switch_is_use', {
                                id: record.id,
                                status: record.is_use == 1 ? 0 : 1
                            }).then((res: any) => {
                                resetForm()
                            })
                        }} />
                    </Space>
                )} />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {permission.includes('编辑') && <Button type="primary" onClick={() => {
                                form.setFieldsValue({
                                    "store_id": record.store_id,
                                    "material_type_id": record.material_type_id,
                                    "material_name": record.material_name,
                                    "material_code": record.material_code,
                                    "material_unit": record.material_unit,
                                    "cost_price": record.cost_price,
                                    "is_use": record.is_use
                                })

                                setRecordID(record.id)
                                setAddVisible(true)
                            }}>编辑</Button>}
                        </Space>)
                    }}
                />
            </Table>
        </div>

        {/* 月子中心 -> 月子配置管理 -> 物料管理 -> 新增或编辑 */}
        <Modal title={recordID ? "编辑物料" : "新增物料"} visible={addVisible} onCancel={() => { setAddVisible(false) }} footer={false} width="500px">
            <Form {...formItemLayout} name="validate_other" form={form} onFinish={onFinish}>
                <Form.Item label="门店" name="store_id" rules={[{ required: true, message: '必须选择门店' }]} >
                    <Select virtual={false} >{optionStore}</Select>
                </Form.Item>

                <Form.Item label="物料分类" name="material_type_id" rules={[{ required: true, message: '必须选择物料分类' }]} >
                    <Select virtual={false} >{optionType}</Select>
                </Form.Item>

                <Form.Item label="物料名称" name="material_name" rules={[{ required: true, message: '必须填写物料名称' }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="物料编号" name="material_code">
                    <Input />
                </Form.Item>

                <Form.Item label="物料单位" name="material_unit" rules={[{ required: true, message: '必须填写物料单位' }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="成本价格" name="cost_price" rules={[{ required: true, message: '必须填写成本价格' }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="是否启用" name="is_use" rules={[{ required: true, message: '必须选择是否启用' }]} >
                    <Select virtual={false} >
                        <Option value={1} key={1}>启用</Option>
                        <Option value={0} key={0}>未启用</Option>
                    </Select>
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}